import mockUsernames from "../utils/mockUsernames";
import mockUsernamesAddons from "../utils/mockUsernamesAddons";

const initial =
  mockUsernames[Math.floor(Math.random() * mockUsernames.length) + 1];

const extension =
  mockUsernamesAddons[
    Math.floor(Math.random() * mockUsernamesAddons.length) + 1
  ];

const number = Math.floor(Math.random() * 9) + 1;

export const generateRandomUsername = `${initial}${extension}${number}`;
